// extracted by mini-css-extract-plugin
export default {"navMenu":"NavMenu_navMenu__e38GM","subMenu":"NavMenu_subMenu__yDRa4"};